import { createFileRoute } from "@tanstack/react-router";
import { preloadSourcingEntriesQueries } from "@/pages/admin-sourcing-entries/api/preload-sourcing-entries-queries";
import { searchParams } from "@/pages/admin-sourcing-entries/model/search-params";
import { SourcingEntriesPage } from "@/pages/admin-sourcing-entries/ui/sourcing-entries-page";

export const Route = createFileRoute(
  "/_authed/$companySlug/admin/sourcing/entries/",
)({
  component: SourcingEntriesPage,
  loaderDeps: ({ search }) => search,
  loader: ({ deps }) => preloadSourcingEntriesQueries(deps),
  validateSearch: searchParams,
});
